// File Name: src/pages/SignInPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, Form, Input, Button, Typography, message } from 'antd';
import { MailOutlined, LockOutlined, GoogleOutlined } from '@ant-design/icons';
import { signInWithEmail, signInWithGoogle } from '../lib/firebase';

const { Title, Text } = Typography;

const SignInPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const cardStyle = {
    maxWidth: 400,
    margin: '60px auto',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await signInWithEmail(values.email, values.password);
      message.success('Sign in successful! Welcome back.');
      navigate('/'); // Navigate to home or dashboard after sign in
    } catch (error) {
      console.error('Sign In Error:', error);
      message.error(error.message || 'Failed to sign in. Check your credentials.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
      await signInWithGoogle();
      message.success('Signed in with Google successfully!');
      navigate('/');
    } catch (error) {
      console.error('Google Sign In Error:', error);
      message.error(error.message || 'Failed to sign in with Google.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" style={{ minHeight: '80vh', backgroundColor: '#F0F2F5' }}>
      <Col>
        <Card style={cardStyle}>
          <Title level={3} style={{ textAlign: 'center', color: '#6e4598' }}>Sign In to Yalla Nellab</Title>
          
          <Button 
            icon={<GoogleOutlined />}
            size="large"
            block
            style={{ marginBottom: 20, backgroundColor: '#4285F4', color: 'white' }}
            onClick={handleGoogleSignIn}
            loading={loading}
          >
            Sign In with Google
          </Button>

          <div style={{ textAlign: 'center', margin: '15px 0' }}>
            <Text type="secondary">OR SIGN IN WITH EMAIL</Text>
          </div>
          
          <Form
            name="signin"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: 'Please input your Email!' }, { type: 'email', message: 'The input is not valid E-mail!' }]}
            >
              <Input prefix={<MailOutlined />} placeholder="Email" size="large" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input your Password!' }]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Password" size="large" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" size="large" block loading={loading} style={{ backgroundColor: '#6e4598', borderColor: '#6e4598' }}>
                Sign In
              </Button>
            </Form.Item>
          </Form>
          
          <div style={{ textAlign: 'center' }}>
            <Text>
              Don't have an account? <Button type="link" onClick={() => navigate('/signup')} style={{ padding: 0 }}>Sign Up</Button>
            </Text>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default SignInPage;